import React from "react";
import SearchLayout from "../layout/searchLayout";
import All from "./all";

function AllResults() {
  return (
    <SearchLayout containerClassName="all-container" showResultsContainer={false}>
      <All />
    </SearchLayout>
  );
}

export default AllResults;
